import { useState } from 'react';
import { Tags, Loader2 } from 'lucide-react';
import axios from 'axios';
import { API } from '@/App';

function AdminTagButton({ user, token }) {
  const [tagging, setTagging] = useState(false);
  const [message, setMessage] = useState('');
  const [showMessage, setShowMessage] = useState(false);

  // Check if user is admin
  const ADMIN_EMAILS = ["jschoes@msn.com", "jamespschuler@gmail.com"];
  const isAdmin = user && ADMIN_EMAILS.includes(user.email);

  if (!isAdmin) {
    return null;
  }

  const handleTagArticles = async () => {
    setTagging(true);
    setMessage('');
    setShowMessage(false);

    try {
      const response = await axios.post(`${API}/admin/tag-articles`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setMessage(response.data.message);
      setShowMessage(true);

      // Hide message after 5 seconds
      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Failed to tag articles';
      setMessage(errorMsg);
      setShowMessage(true);

      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    } finally {
      setTagging(false);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={handleTagArticles}
        disabled={tagging}
        className="flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors text-white text-xs sm:text-sm font-medium disabled:opacity-50"
        title="Tag untagged articles with AI"
      >
        {tagging ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <Tags className="w-4 h-4" />
        )}
        <span className="hidden sm:inline">
          {tagging ? 'Tagging...' : 'Auto-Tag'}
        </span>
      </button>

      {/* Success/Error Message */}
      {showMessage && (
        <div className="absolute top-full right-0 mt-2 w-64 p-3 bg-card border border-border rounded-lg shadow-lg text-sm z-50">
          {message}
        </div>
      )}
    </div>
  );
}

export default AdminTagButton;
